
import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import GaranzieActions from './garanzie_actions';
import { Utils, domainVal, domain, NumberFormatter, i18n, opt, DateFormatter, isAuth } from 'arm-common';
import { ConfirmModalOkCancelV4, ConfirmModalSaveV4, ConfirmModalV4 } from '../shared/v4';
import Editor from 'react-simple-code-editor';


class CreateGaranzia extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CreateGaranzia.jsx] ';
        this.state = {
            validation: new Map(),
            showConfirm: false,
            
        };
        this.annullaButton = this.annullaButton.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        // this.state = this.getInitalState();
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.salvaGaranzia = this.salvaGaranzia.bind(this);
        this.validateForm = this.validateForm.bind(this);

    }
    
    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        if (!this.props.location.state) {
            this.props.clearAll();

        }
    }

    annullaButton() {
        console.log(this.componentName + 'annullaButton');
        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.history.push({ pathname: '/garanzie/details', state: { id: this.props.location.state.id } });
        } else if (this.props.location.state && this.props.location.state.gruppoProdotto) {
            this.props.history.push({ pathname: '/microCategorie/create', state: { modifica: true } });
        }
        else if (this.props.location.state && this.props.location.state.prodotto) {
            this.props.history.push({ pathname: '/prodotto/create', state: { modifica: true } });
        }
        else {
            this.props.history.goBack();
        }

    }
    showConfirmPanel() {

        this.props.showPopUP(!this.props.showConfirm);
    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['nome', 'codRamo', 'codBisogno'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.garanzia[required[i]] === undefined || this.props.garanzia[required[i]] === '' || this.props.garanzia[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            // this.setState({ showConfirm: !this.state.showConfirm });
            this.showConfirmPanel();
            return true;
        }
        // $("#modalConfirm").modal("close");

        return false;
    }

    salvaGaranzia() {

        console.log(this.componentName + 'salvaGaranzia');

        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }
        this.props.salvaGaranzia(this.props.history);

        console.log("\tloginOnClick - end");
    }



    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + 'inputChangeHandler' + id);

            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }
         
            this.props.handleChange(id, value);
        }
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div>
                <agui.aCardV4 className="mt-3 mb-3 inner-card">
                    <agui.aCardV4Header>
                        {this.props.location.state && this.props.location.state.modifica ?
                            <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                {i18n('ARM_CORE_PRODUCT.GARANZIE.MODIFICA_GARANZIA_CON_ID', 'Modifica Garanzia con id')} {this.props.location.state.id}
                            </div>
                            :
                            this.props.location.state && (this.props.location.state.microCategoria || this.props.location.state.prodotto) ?
                                <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                    {i18n('ARM_CORE_PRODUCT.GARANZIE.CREAZIONE_NUOVA_GARANZIA_MICRO_CATEGORIA', 'Creazione Nuova Garanzia per la micro-categoria')} {this.props.garanzia.idMicroCategoria ? this.props.garanzia.idMicroCategoria : null}: {this.props.garanzia.nomeMicroCategoria ? this.props.garanzia.nomeMicroCategoria : null}
                                </div>
                                :
                                <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                    {i18n('ARM_CORE_PRODUCT.GARANZIE.CREAZIONE_NUOVA_GARANZIA', 'Creazione Nuova Garanzia')}
                                </div>
                        }
                    </agui.aCardV4Header>
                    <agui.aCardV4Body>
                        <div>
                            <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="nome" type="text"
                                        value={this.props.garanzia.nome}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_NOME', 'inserire nome')}
                                        required
                                        label={i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler} />
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="sigla" type="text"
                                        value={this.props.garanzia.sigla}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_SIGLA', 'inserire sigla')}
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ASelectV4
                                        id="codRamo"
                                        disabled={false}
                                        required={true}
                                        onChange={this.inputChangeHandler}
                                        value={this.props.garanzia.codRamo}
                                        validation={this.state.validation}
                                        label={i18n('ARM_CORE_PRODUCT_RAMO_GARANZIA', 'Ramo Garanzia')}
                                        items={domain("AI_RAMO_GARANZIA")}
                                        valueKey="valCampo"
                                        labelKey="desDom"
                                    />
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ASelectV4
                                        id="codBisogno"
                                        disabled={false}
                                        required={true}
                                        //classNameComponent="row"
                                        //classNameLabel="col-4"
                                        onChange={this.inputChangeHandler}
                                        value={this.props.garanzia.codBisogno}
                                        validation={this.state.validation}
                                        label={i18n('ARM_CORE_PRODUCT.AI_BISOGNO', 'Bisogno')}
                                        items={domain("AI_BISOGNO")}
                                        // label={i18n('ARM_CORE_PRODUCT.GARANZIE.TIPO_ALIQUOTA', 'Tipo Aliquota')}
                                        // {this.state.tipiAliquota}
                                        valueKey="valCampo"
                                        labelKey="desDom"
                                    />
                                </div>
                                
                                <div className=" col-12 " style={{height: "auto"}}>
                                <textarea className="form-control "
                                    id="note"
                                    rows="4"
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_NOTE', 'inserire note')}
                                    onChange={this.inputChangeHandler}
                                    value={this.props.garanzia.note}
                                />
                                </div>
                            </div>
                        </div>
                        <br></br>

                    </agui.aCardV4Body>
                    <agui.aCardFooter>
                        <div>
                            <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.validateForm}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}</agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.annullaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCardV4 >
                <ConfirmModalSaveV4
                    testoTitle = {i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoBody = {this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI.VOLER.SALV','Confermi di voler salvare?')}
                    testoButtonConfirm = {i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoButtonCancel = {i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    show={this.props.showConfirm}
                    saveOnClick={this.salvaGaranzia}
                    onClose={this.showConfirmPanel} />

            </div>

        );
    }
}
function mapStateToProps(state) {
    return {
        garanzia: state.garanzie.detailsGaranzia,
        showConfirm: state.app.showPopUp,
    }
}

function mapDispatchToProps(dispatch) {
    return {

        salvaGaranzia(history) {
            return dispatch(GaranzieActions.salvaGaranzia(history));
        },
        handleChange(index, e) {
            return dispatch(GaranzieActions.handleChange(index, e))
        },
        clearAll() {
            return dispatch(GaranzieActions.clearAll());
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateGaranzia);
